import { SigninRedirectArgs, User, UserManager, UserManagerSettings } from "oidc-client-ts";
import { oiauth } from "../environments/auth";

const settings: UserManagerSettings = oiauth;

export const userManager = new UserManager(settings);

export function getUser()
{
    return userManager.getUser();
}

export function login(email?: string)
{
    const additional: SigninRedirectArgs = {
        extraQueryParams: {
            "origin": window.location.origin
        }
    };

    if(email)
    {
        additional.extraQueryParams = {
            ...additional.extraQueryParams,
            "username": email
        };
    }
    return userManager.signinRedirect(additional);
}

export async function renewToken(): Promise<User | null>
{
    try {
        console.debug("renewToken...");
        return await userManager.signinSilent();
    } 
    catch (error) 
    {
        console.error("error  renewToken: ",error);
        try
        {
            // Logs user again into platform
            // await userManager.signinRedirect();
            console.debug("go userManager.signinRedirect");
            const directPath = window.location.pathname + window.location.search;
            await userManager.signinRedirect({state: {
                currentHref: directPath
            }});
            console.debug("signinSilentCallback succesful");
            return userManager.getUser();
        }
        catch(err)
        {
            console.error("Sign in redirect", err);
            return Promise.reject(err);
        }
    }
}

export function logout()
{
    sessionStorage.removeItem("contacts_cache");
    return userManager.signoutRedirect();
}
